type Props = {
  tag: string
}

export default function Tag({ tag }: Props) {
  return <li className='bg-green-500/25 text-green-600 dark:text-green-500 rounded-full px-3 py-0.5 text-sm mr-3 mt-4'>{tag}</li>
}
